import React from 'react';
import { Button } from 'antd';

function AdnSaveButton({ loading }) {
    return (
        <Button type="primary" htmlType="submit" loading={loading} className='adn-primary-button'>
            Save
        </Button>
    );
}

export default AdnSaveButton;
